var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupPrincipIntersekcionalnosti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165 165",
    style: {
      enableBackground: "new 0 0 165 165"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6E5DD8;}\n\t.st1{fill:#FA7268;}\n\t.st2{fill:#AA6276;}\n\t.st3{fill:#159497;}\n\t.st4{fill:none;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st6{fill:#231F20;}\n\t.st7{fill:none;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st10{fill:#6E5DD8;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{fill:#FFFFFF;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FFFFFF;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st19{fill:#FFFFFF;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st20{fill:#FA7268;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:#FA7267;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 82.6,
    cy: 47.4,
    r: 40.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 53.3,
    cy: 100.4,
    r: 40.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 111.7,
    cy: 100.4,
    r: 40.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.2,87.1c3,0.7,6.2,1.1,9.4,1.1c17.9,0,33-11.5,38.6-27.5c-3-0.7-6.2-1.1-9.4-1.1 C93.9,59.6,78.7,71.1,73.2,87.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 82.5,
    cy: 100.4,
    rx: 11.6,
    ry: 28.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44,60.7c5.5,16,20.7,27.5,38.6,27.5c3.2,0,6.3-0.4,9.3-1.1c-5.5-16-20.7-27.5-38.6-27.5 C50.1,59.6,47,60,44,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85.2,88.1c2.3-0.1,4.5-0.5,6.7-1c-2-5.7-5.2-10.9-9.3-15.1c-4.1,4.2-7.3,9.4-9.3,15.1c2.2,0.5,4.4,0.9,6.8,1 c0.1,0,0.3,0,0.4,0c0.7,0,1.5,0.1,2.2,0.1c0.7,0,1.5,0,2.2-0.1C84.9,88.1,85,88.1,85.2,88.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupPrincipIntersekcionalnosti);
export default __webpack_public_path__ + "static/media/Signup-princip_intersekcionalnosti.87d49c23c9ac9f4cfe3aef9b26432d35.svg";
export { ForwardRef as ReactComponent };